module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAH9JREFUGBl9kNENgCAMRBu3YBgcxTVIdCvmcA528EPxnikfGpDkgPZeWqiZr2oWpSwVF/fY/OdUYpUuqX504jVodujQmaTg4k4OOJo2WlApvdooIOdeJuBNgKEDUh2vTF9zFAPubi4dqOV2WjMWHvz/GaoI2hwej6e1E0jl4cBvBJZmoWzTPLQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/patch Deactivated.png
// module id = 115
// module chunks = 7